import api from "./axios";
import { apiPaths } from "./paths";
import type { AuthUser, ApiMessage } from "@/types";

const apiOrigin = (process.env.API_URL || "").replace(/\/$/, "");

export const getGoogleAuthUrl = () => `${apiOrigin}/api${apiPaths.auth.google}`;

export const logout = () =>
  api.post<ApiMessage>(apiPaths.auth.logout).then((r) => r.data);

export const getMe = () =>
  api.get<AuthUser>(apiPaths.users.me).then((r) => r.data);

export const deleteMyAccount = () =>
  api.delete<ApiMessage>(apiPaths.users.me).then((r) => r.data);
